import React, { useState, useEffect } from 'react';

import { FullHeightContainer } from '../Containers';
import { Header } from '../Header';
import { ButtonBar } from '../ButtonBar';
import { AppHeader } from '../AppHeader';

import { createEnterExitAnimation } from '../../transitions';
import { animationDelay } from '../../constants';
import { createMarkup } from '../../utils';

interface IProps {
    stepNumber: number;
    headerText: string;
    totalSteps: number;
    onAnimationExit(): void;
    onBackButtonClick?(): void;
    onCloseButtonClick?(): void;
}

export const OutroView: React.FC<IProps> = ({
    onAnimationExit,
    headerText,
    stepNumber,
    totalSteps,
    onBackButtonClick,
    onCloseButtonClick,
}) => {
    const [componentStage, setComponentStage] = useState('enter');

    useEffect(() => {
        const timeout = setTimeout(() => {
            setComponentStage('exit');
        }, 1500);

        return () => {
            clearTimeout(timeout);
        };
    });

    const handleAnimationExit = () => {
        if (componentStage === 'exit') {
            onAnimationExit();
        }
    };

    return (
        <>
            <AppHeader
                totalSteps={totalSteps}
                stepNumber={stepNumber}
                onBackButtonClick={onBackButtonClick}
                onCloseButtonClick={onCloseButtonClick}
            />
            <FullHeightContainer>
                <Header
                    style={createEnterExitAnimation({
                        stage: componentStage,
                        delay: animationDelay.first,
                        onRest: handleAnimationExit,
                    })}
                    dangerouslySetInnerHTML={createMarkup(headerText)}
                />
            </FullHeightContainer>
            <ButtonBar />
        </>
    );
};
